import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Menu, MenuItem } from "react-pro-sidebar";
import { api_path } from "../shared";

const SidebarMenu = () => {
  const [menuList, setMenuList] = useState([]);

  useEffect(() => {
    const role = localStorage.getItem("USER_ROLE_ID");
    if (role && role !== "undefined") {
      const getUserRole = JSON.parse(role);
      const getUserEmail = JSON.parse(localStorage.getItem("USER_EMAIL"));
      const data = {
        ROLE_ID: getUserRole,
        USER_EMAIL: getUserEmail,
        MENU_URL: "/",
      };

      fetch(api_path + "/MS_MENU.php", {
        method: "POST",
        headers: {
          Accept: "application/form-data",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => setMenuList(res))
        .catch(() => setMenuList([]));
    } else {
      setMenuList([]);
    }
  }, []);

  // 🔹 ถ้ามีเมนูจาก API
  if (menuList.length > 0) {
    return (
      <Menu
        menuItemStyles={{
          button: ({ level, active }) => {
            if (level === 0 || level === 1)
              return {
                backgroundColor: active
                  ? "rgba(30, 167, 253, 0.15)"
                  : "#FFFFFF",
                color: "#000000",
              };
          },
        }}
      >
        {menuList.map((menu) => (
          <MenuItem
            key={menu.MENU_ID}
            component={<Link to={menu.MENU_URL} />}
            active={window.location.pathname === menu.MENU_URL}
            icon={<NavigateNextIcon fontSize="small" />}
            className="menuItem"
          >
            {menu.MENU_TEXT}
          </MenuItem>
        ))}
      </Menu>
    );
  }

  // 🔹 ถ้าไม่มีเมนู (ยังไม่ได้ login หรือ API ว่าง)
  return (
    <Menu
      menuItemStyles={{
        button: ({ level, active }) => {
          if (level === 0 || level === 1)
            return {
              backgroundColor: active
                ? "rgba(30, 167, 253, 0.15)"
                : "#FFFFFF",
              color: "#000000",
            };
        },
      }}
    >
      <MenuItem
        component={<Link to="/s-crm/Register" />}
        icon={<NavigateNextIcon fontSize="small" />}
        active={window.location.pathname === "/s-crm/Register"}
        className="menuItem"
      >
        Your Profile
      </MenuItem>
      <MenuItem
        component={<Link to="/s-crm/logout" />}
        icon={<NavigateNextIcon fontSize="small" />}
        className="menuItem"
      >
        Sign out
      </MenuItem>
    </Menu>
  );
};

export default SidebarMenu;
